<div class="flex items-center space-x-16">
  <p class="mt-3" id="sd-last-updated">{{ lastUpdated }}</p>
  <button
    *ngIf="isEligible && isUserPmOrAboveOrHoSD"
    class="p-0 bg-transparent border-none cursor-pointer text-darkBlue-600"
    id="Single-SD-Proxy-Vote-Button"
    (click)="openProxyVoteModal()"

  >
    Proxy Vote
  </button>
</div>
